import React from 'react'
import {useDialogContext} from '../Dialog/DialogContext'
import {Row} from 'jsxstyle'

type ConfirmDialogButtonProps = {
  closeOnClick?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  customButtonProps?: Partial<React.ComponentProps<typeof Row>>
} & React.HTMLAttributes<HTMLButtonElement>

const ConfirmDialogButton: React.FC<ConfirmDialogButtonProps> = ({closeOnClick = true, onClick, customButtonProps, ...props}) => {
  const {close} = useDialogContext()

  return (
    <Row
      display="flex"
      component="button"
      backgroundColor="#1976D2"
      color="#FFFFFF"
      border="none"
      padding="10px 20px"
      gap="8px"
      borderRadius="8px"
      fontSize="16px"
      fontWeight={500}
      cursor="pointer"
      transition="background-color 0.3s, transform 0.2s"
      hoverBackgroundColor="#155A9C"
      textAlign="center"
      alignItems="center"
      justifyContent="center"
      style={{transform: 'scale(0.98)'}}
      {...customButtonProps}
      {...props}
      props={{
        onClick: async (e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation()
          await onClick?.(e)
          closeOnClick && close()
        },
      }}
    />
  )
}

export default ConfirmDialogButton
